import React, { useState } from 'react';
import { adminCarPublishService } from '../../../services/adminService';

const PublishCarModal = ({ inspection, onClose, onSuccess }) => {
  const [processing, setProcessing] = useState(false);

  // Calls PUT /api/v1/admin/cars/:car_id/publish
  // Backend: ready_for_publish? → sets listing_status: 'live', published_at
  const handlePublish = async () => {
    if (!window.confirm('Publish this car? It will become visible to buyers immediately.')) return;
    try {
      setProcessing(true);
      const result = await adminCarPublishService.publishCar(inspection.car_id);
      console.log('✅ Car published:', result);
      alert('🚀 Car published successfully! It is now live on the platform.');
      onSuccess();
    } catch (err) {
      console.error('Publish error:', err);
      alert('Failed: ' + (err.response?.data?.message || err.message));
    } finally {
      setProcessing(false);
    }
  };

  const car = inspection.car;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <h2>🚀 Publish Car</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="car-preview">
            <h3>
              {inspection.sell_request?.brand} {inspection.sell_request?.model} {inspection.sell_request?.year}
            </h3>
            <p>📍 {inspection.city} • 🛣️ {Number(inspection.sell_request?.km_driven || 0).toLocaleString()} km</p>
            <p><strong>🚗 Car ID:</strong> #{inspection.car_id}</p>
            <p>
              <strong>💰 Price:</strong>{' '}
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                ₹{Number(inspection.estimated_price || 0).toLocaleString()}
              </span>
            </p>
          </div>

          {/* Pre-publish checklist */}
          <div style={{ marginTop: '16px', padding: '12px', background: '#f0fff4', border: '1px solid #c6f6d5', borderRadius: '8px' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>✅ Pre-publish checklist:</p>
            <div style={{ fontSize: '13px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ color: '#28a745' }}>✅ Inspection approved</span>
              <span style={{ color: '#28a745' }}>✅ Price accepted by seller</span>
              <span style={{ color: car?.owned_by_platform ? '#28a745' : '#dc3545' }}>
                {car?.owned_by_platform ? '✅' : '❌'} Buyer listing prepared
              </span>
              <span style={{ color: car?.content_verified ? '#28a745' : '#dc3545' }}>
                {car?.content_verified ? '✅' : '❌'} Content verified
              </span>
              <span style={{ color: car?.listing_status === 'draft' ? '#28a745' : '#dc3545' }}>
                {car?.listing_status === 'draft' ? '✅' : '❌'} Status is draft (ready to publish)
              </span>
            </div>
          </div>

          <p style={{ marginTop: '12px', color: '#555', fontSize: '13px', lineHeight: '1.5' }}>
            Publishing will make this car immediately visible to buyers on the platform.
            This action cannot be undone without manual intervention.
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn-modal-cancel" onClick={onClose} disabled={processing}>
            Cancel
          </button>
          <button
            className="btn-modal-submit btn-publish-confirm"
            onClick={handlePublish}
            disabled={processing}
          >
            {processing ? '⏳ Publishing…' : '🚀 Publish Now'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default PublishCarModal;